import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { BRAND } from "@/lib/biohackerBrand";

export default function SiteFooter() {
  return (
    <footer className="border-t border-white/8 bg-[#050810]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 py-12 grid md:grid-cols-4 gap-8">
        <div>
          <Logo size="md" variant="lockup" linkTo="/" dark />
          <p className="mt-4 text-xs text-white/50 leading-relaxed max-w-xs">
            {BRAND.parentTrademark}<br/>
            {BRAND.category}<br/>
            <span className="text-white/35">{BRAND.tagline}</span>
          </p>
        </div>
        <FooterCol title="Platform" links={[
          { to: "/platform",   label: "Platform" },
          { to: "/technology", label: "Technology" },
          { to: "/pricing",    label: "Pricing" },
        ]} />
        <FooterCol title="Sports" links={[
          { to: "/sports",           label: "Sport Intelligence Packages™" },
          { to: "/sports/baseball",  label: "BioHacker Baseball™" },
          { to: "/mental-performance", label: "Mental Performance & Wellness™" },
        ]} />
        <FooterCol title="Company" links={[
          { to: "/solutions",     label: "Solutions" },
          { to: "/enterprise",    label: "Enterprise" },
          { to: "/resources",     label: "Resources" },
          { to: "/compliance",    label: "Trust & Compliance" },
          { to: "/request-demo",  label: "Request demo" },
          { to: "/terms",         label: "Terms" },
          { to: "/privacy",       label: "Privacy" },
        ]} />
      </div>
      <div className="border-t border-white/8">
        <div className="max-w-7xl mx-auto px-6 py-4 flex flex-wrap items-center justify-between gap-2 text-[10px] uppercase tracking-[0.3em] text-white/35">
          <span>© {new Date().getFullYear()} BioHacker Sports™. All rights reserved.</span>
          <div className="flex flex-wrap items-center gap-2" data-testid="footer-compliance-badges">
            <Link to="/compliance" className="px-2 py-1 rounded-full border border-amber-500/40 text-amber-300 hover:border-amber-400" title="SOC 2 Type II audit in progress">
              SOC 2 · in progress
            </Link>
            <Link to="/compliance" className="px-2 py-1 rounded-full border border-cyan-500/40 text-cyan-300 hover:border-cyan-400" title="HIPAA-aligned · BAA available">
              HIPAA-aligned
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <div className="text-[10px] tracking-[0.3em] uppercase font-bold text-white/45 mb-3">{title}</div>
      <ul className="space-y-2">
        {links.map((l) => (
          <li key={l.to}>
            <Link to={l.to} className="text-sm text-white/70 hover:text-white transition-colors">
              {l.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
